// PrimeNG v18+ has no equivalent to the old 10 CSS-file themes — theming is now
// a single Aura-based preset (see commons/lumberlinq-preset.ts) with light/dark
// switched via the `.app-dark` class on <html> (see ThemeService).
export enum Theme {
  Light = 'light',
  Dark = 'dark',
}
